import script from "./reservation.vue?vue&type=script&setup=true&lang=js"
export * from "./reservation.vue?vue&type=script&setup=true&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=05676170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05676170"]])

export default __exports__